// ==========================================================================
// components/AssetSelect.tsx — "which vehicle / which property" for a coded
// line (9 Oct 2026). Shown only when the budget code belongs to one:
// transport codes → vehicles, 800s and 140 Rent → properties (lib/property).
// ==========================================================================
import { inputCls } from "@/components/Sheet";
import { assetKindFor, useAssetOptions } from "@/lib/property";
import type { Category } from "@/lib/money";

export default function AssetSelect({ categoryId, cats, value, onChange, compact = false }: {
  categoryId: string | null | undefined; cats: Category[]; value: string | null; onChange: (id: string | null) => void; compact?: boolean;
}) {
  const kind = assetKindFor(categoryId, cats); const assets = useAssetOptions();
  if (!kind) return null;
  const list = (assets.data ?? []).filter((a) => a.kind === kind && (!a.disposed_on || a.id === value));
  return (
    <select value={value ?? ""} onChange={(e) => onChange(e.target.value || null)} className={`${inputCls} ${compact ? "py-2 text-sm" : ""}`} aria-label={kind === "vehicle" ? "Vehicle" : "Property"}>
      <option value="">{kind === "vehicle" ? "No vehicle" : list.length ? "Which property?" : "No property yet (add one under Property)"}</option>
      {list.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
    </select>
  );
}
